export default __webpack_public_path__ + "static/media/astronaut.cd5195f8.jpg";